import SnackbarUtils from '@/components-triggers/snackbar/snackbar-utils';

// To handle setTimeout
jest.useFakeTimers();

describe('Snackbar utils unit tests', () => {
    it('should create snackbar with default properties', () => {
        const spyCreate = jest.spyOn(SnackbarUtils, 'createSnackbar');
        SnackbarUtils.pushNotification('Test');
        expect(spyCreate).toHaveBeenCalledWith('Test', {level: 'success', duration: 5000, closable: true, action: {}});
    });

    it('should create snackbar with given properties', () => {
        const spyCreate = jest.spyOn(SnackbarUtils, 'createSnackbar');

        SnackbarUtils.pushNotification('Test', {level: 'error'});
        expect(spyCreate).toHaveBeenCalledWith('Test', {level: 'error', duration: 5000, closable: true, action: {}});

        SnackbarUtils.pushNotification('Test', {level: 'info', duration: 1000});
        expect(spyCreate).toHaveBeenCalledWith('Test', {level: 'info', duration: 1000, closable: true, action: {}});

        SnackbarUtils.pushNotification('Test', {duration: 2000, closable: false});
        expect(spyCreate).toHaveBeenCalledWith('Test', {level: 'success', duration: 2000, closable: false, action: {}});
    });

    it('should create snackbar with given properties with action', () => {
        const spyCreate = jest.spyOn(SnackbarUtils, 'createSnackbar');

        SnackbarUtils.pushNotification('Test', {action: {text: 'Trigger action'}});

        expect(spyCreate).toHaveBeenCalledWith('Test', {
            level: 'success',
            duration: 5000,
            closable: true,
            action: {
                text: 'Trigger action',
            },
        });
    });
});
